import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function DiaperForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [type, setType] = useState("wet");
  const [color, setColor] = useState("");
  const [consistency, setConsistency] = useState("");
  const [notes, setNotes] = useState("");

  const isDirty = type === "dirty" || type === "both";

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd({
      date: new Date(date).toISOString(),
      type,
      color: isDirty ? color : "",
      consistency: isDirty ? consistency : "",
      notes: notes || "",
    });
    setDate(toDatetimeLocal());
    setType("wet");
    setColor("");
    setConsistency("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Type</label>
          <select
            className="form-select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="wet">💧 Wet</option>
            <option value="dirty">💩 Dirty</option>
            <option value="both">💧💩 Both</option>
          </select>
        </div>
        {isDirty && (
          <>
            <div className="col-md-2">
              <label className="form-label">Color</label>
              <select
                className="form-select"
                value={color}
                onChange={(e) => setColor(e.target.value)}
              >
                <option value="">Select</option>
                <option value="yellow">Yellow</option>
                <option value="brown">Brown</option>
                <option value="green">Green</option>
                <option value="black">Black (meconium)</option>
                <option value="red">Red</option>
                <option value="white/clay">White/Clay</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="col-md-2">
              <label className="form-label">Consistency</label>
              <select
                className="form-select"
                value={consistency}
                onChange={(e) => setConsistency(e.target.value)}
              >
                <option value="">Select</option>
                <option value="watery">Watery</option>
                <option value="seedy">Seedy</option>
                <option value="pasty">Pasty</option>
                <option value="formed">Formed</option>
                <option value="hard">Hard</option>
              </select>
            </div>
          </>
        )}
        <div className={`col-md-${isDirty ? 2 : 5}`}>
          <label className="form-label">Notes</label>
          <input
            type="text"
            className="form-control"
            placeholder="Optional"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
        <div className="col-md-1 d-flex align-items-end">
          <button type="submit" className="btn btn-primary w-100">
            Add
          </button>
        </div>
      </div>
    </form>
  );
}
